// Clean Product Enhancements - Wishlist + Notify Me (Allen Solly Style)
document.addEventListener('DOMContentLoaded', function() {
  
  // Debug mode - change to true for troubleshooting
  const DEBUG = false;
  
  // Prevent popups during initial page load
  let isInitializing = true;
  
  function log(message, data) {
    if (DEBUG) console.log('[NOTIFY]', message, data || '');
  }

  // Update Buy Now button state based on Add to Cart availability
  function updateBuyNowButtons() {
    const addToCartBtn = document.querySelector('[name="add"]');
    const buyNowBtns = document.querySelectorAll('.shopify-payment-button button, .additional-checkout-buttons button');
    const isOutOfStock = addToCartBtn && addToCartBtn.disabled;
    
    log('Updating Buy Now buttons. Out of stock:', isOutOfStock);
    
    buyNowBtns.forEach(btn => {
      btn.disabled = isOutOfStock;
      btn.style.opacity = isOutOfStock ? '0.5' : '1';
      btn.style.cursor = isOutOfStock ? 'not-allowed' : 'pointer';
    });
  }

  // Open notify me popup
  function openNotifyPopup() {
    const modalButton = document.querySelector('[data-modal="#PopupModal-4"] button');
    log('Opening notify popup. Modal button found:', !!modalButton);
    
    if (modalButton) {
      modalButton.click();
    } else {
      log('Modal button not found - cannot open popup');
    }
  }

  // Initial setup - no automatic testing to prevent glitches
  updateBuyNowButtons();
  
  // Allow popups after initial load is complete
  setTimeout(() => {
    isInitializing = false;
    log('Initialization complete - popups now allowed');
  }, 3000);
  
  log('Setup complete');

  // Global click handler for variant options
  document.addEventListener('click', function(e) {
    const target = e.target;
    
    // Ignore wishlist clicks
    if (target.closest('wishlist-item')) {
      log('Wishlist click ignored');
      return;
    }
    
    // Handle variant option clicks (labels and radio inputs)
    if (target.matches('label') || target.closest('label') || target.matches('input[type="radio"]')) {
      let input = null;
      
      // Get the radio input for this variant
      if (target.matches('input[type="radio"]')) {
        input = target;
      } else {
        const label = target.matches('label') ? target : target.closest('label');
        const forAttr = label?.getAttribute('for');
        if (forAttr) {
          input = document.getElementById(forAttr);
        }
      }
      
      log('Variant clicked. Input found:', !!input, 'Type:', input?.type);
      
      // If it's a valid radio input for variants
      if (input && input.type === 'radio') {
        // Get the label for this input
        const label = target.matches('label') ? target : target.closest('label') || document.querySelector(`label[for="${input.id}"]`);
        
        // Wait for variant to be processed, then check Add to Cart button
        setTimeout(() => {
          // Skip if still initializing
          if (isInitializing) {
            log('Popup blocked - still initializing');
            return;
          }
          
          const addToCartBtn = document.querySelector('[name="add"]');
          
          // Simple check: button text contains "sold out" (case insensitive)
          const buttonText = addToCartBtn ? addToCartBtn.textContent.toLowerCase().trim() : '';
          const isSoldOut = buttonText.includes('sold out');
          
          log('Variant clicked - Button text:', buttonText, 'Is sold out:', isSoldOut);
          
          if (isSoldOut) {
            log('Showing notify popup for sold out variant');
            openNotifyPopup();
          }
        }, 500);
      }
    }
  });

  // Watch for variant changes to update Buy Now buttons
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"], select')) {
      log('Variant selection changed');
      setTimeout(updateBuyNowButtons, 100);
    }
  });

  // Observe Add to Cart button state changes
  const addToCartBtn = document.querySelector('[name="add"]');
  if (addToCartBtn) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
          log('Add to Cart button state changed');
          updateBuyNowButtons();
        }
      });
    });
    observer.observe(addToCartBtn, { attributes: true });
    log('Observing Add to Cart button changes');
  }



  log('All event listeners set up successfully');
});